import React from "react";
import { Box, Container, Text, Flex } from "@chakra-ui/react";
import { motion } from "framer-motion";
import { AppStoreLinks } from "../AppStoreLinks/AppStoreLinks";

const MotionBox = motion(Box);

export const FinalCTA = () => {
  return (
    <Box
      bg="#293452"
      py={{ base: "80px", md: "112px" }}
      position="relative"
      overflow="hidden"
      className="dot-grid"
    >
      {/* Radial glow */}
      <Box
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%,-50%)"
        w="700px"
        h="700px"
        borderRadius="50%"
        background="radial-gradient(ellipse, rgba(0,149,200,0.1) 0%, transparent 65%)"
        pointerEvents="none"
      />

      {/* Concentric circles — top right */}
      <Box
        position="absolute"
        top="-80px"
        right="-80px"
        w={{ base: "260px", md: "380px" }}
        h={{ base: "260px", md: "380px" }}
        borderRadius="50%"
        border="48px solid #0095C8"
        opacity="0.18"
        pointerEvents="none"
      />
      <Box
        position="absolute"
        bottom="-100px"
        left="-80px"
        w={{ base: "220px", md: "320px" }}
        h={{ base: "220px", md: "320px" }}
        borderRadius="50%"
        border="40px solid #0095C8"
        opacity="0.1"
        pointerEvents="none"
      />

      <Container maxW="1200px" px={{ base: "5", md: "8" }} position="relative" zIndex={1}>
        <Flex direction="column" align="center" textAlign="center" gap={8}>

          <MotionBox
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Text
              as="h2"
              fontFamily="'Public Sans', sans-serif"
              fontWeight="700"
              fontSize={{ base: "2rem", md: "2.75rem" }}
              color="white"
              lineHeight="1.2"
              maxW="640px"
            >
              Ready to study{" "}
              <Box as="span" bgGradient="linear(135deg, #0095C8, #809CFF)" bgClip="text">
                wherever you are?
              </Box>
            </Text>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.15 }}
          >
            <Text
              fontFamily="'Inter', sans-serif"
              fontSize={{ base: "0.9375rem", md: "1.0625rem" }}
              color="rgba(255,255,255,0.6)"
              maxW="440px"
              lineHeight="1.7"
            >
              Download 31Gauge and start with free, concept-driven MCQs.
            </Text>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.25 }}
          >
            <AppStoreLinks location="final-cta" />
          </MotionBox>

        </Flex>
      </Container>
    </Box>
  );
};
